export default function MergepersonIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="0 0 17.3 16.3"
    >
      <g fill="currentColor" transform="translate(-0.1 -0.1)">
        <path
          d="M2-.65A2.65,2.65,0,1,1-.65,2,2.653,2.653,0,0,1,2-.65Zm0,4A1.35,1.35,0,1,0,.65,2,1.352,1.352,0,0,0,2,3.35Z"
          transform="translate(2.25 0.75)"
        />
        <path
          d="M4.25,7.6A4.155,4.155,0,0,1,8.4,11.75v1.5a.65.65,0,0,1-.65.65H6.838L6.4,18.315a.65.65,0,0,1-.647.585h-3a.65.65,0,0,1-.647-.585L1.662,13.9H.75a.65.65,0,0,1-.65-.65v-1.5A4.155,4.155,0,0,1,4.25,7.6Zm2.85,5v-.85a2.85,2.85,0,1,0-5.7,0v.85h.85a.65.65,0,0,1,.647.585L3.338,17.6H5.162L5.6,13.185A.65.65,0,0,1,6.25,12.6Z"
          transform="translate(0 -2.5)"
        />
        <path
          d="M2-.65A2.65,2.65,0,1,1-.65,2,2.653,2.653,0,0,1,2-.65Zm0,4A1.35,1.35,0,1,0,.65,2,1.352,1.352,0,0,0,2,3.35Z"
          transform="translate(11.25 0.75)"
        />
        <path
          d="M18,18.9H15a.65.65,0,0,1-.647-.585L13.912,13.9H13.5a.65.65,0,0,1,0-1.3h1a.65.65,0,0,1,.647.585l.441,4.415h1.824l.441-4.415A.65.65,0,0,1,18.5,12.6h.85v-.85a2.85,2.85,0,0,0-5.293-1.465.65.65,0,0,1-1.114-.67,4.15,4.15,0,0,1,7.707,2.134v1.5a.65.65,0,0,1-.65.65h-.912l-.441,4.415A.65.65,0,0,1,18,18.9Z"
          transform="translate(-3.25 -2.501)"
        />
      </g>
    </svg>
  );
}
